module.exports = __webpack_public_path__ + "static/carousel1-b691a0dd094c8326807bedb7583eff9c.jpg";